import {dateTimeStringFromApiToDate} from "../../../../index";
import {VejledersamtaleStatusEnum} from "../../../vejledning/vejledersamtaler/VejledersamtaleStatusEnum";
import {Localizer} from "../../../../infrastructure/localization/localizer";
import {
    DashboardUddannelsesplanStatusEnum
} from "../../../vejledning/uddannelsesplan/DashboardUddannelsesplanStatusEnum";

export enum EvalueringStatusEnum {
    Indsendt = 1,
    ManglerIndsendelse = 2,
    Overskredet = 3,
}
export function GetEvalueringString(status: EvalueringStatusEnum): string {
    switch (status) {
        case EvalueringStatusEnum.Indsendt:
            return Localizer.global_indsendt();
        case EvalueringStatusEnum.ManglerIndsendelse:
            return Localizer.dashboard_manglerIndsendelse();
        case EvalueringStatusEnum.Overskredet:
            return Localizer.dashboard_overskredet();
        default:
            return "";
    }
}

export enum AttestationStatusEnum {
    Godkendt = 1,
    IkkeKlarTilGodkendelse = 2,
    ManglerGodkendelse = 3,
}

export function GetAttestationString(status: AttestationStatusEnum): string {
    switch (status) {
        case AttestationStatusEnum.Godkendt:
            return Localizer.global_godkendt();
        case AttestationStatusEnum.IkkeKlarTilGodkendelse:
            return Localizer.dashboard_ikkeKlarTilGodkendelse();
        case AttestationStatusEnum.ManglerGodkendelse:
            return Localizer.dashboard_manglergodkendelse();
        default:
            return "";
    }
}

export const GetEvalueringStatus = (forloebSlutDato: Date, forloebEvalueret: boolean) => {
    if (forloebEvalueret)
        return EvalueringStatusEnum.Indsendt;
    else if (forloebSlutDato < new Date().addDays(30))
        return EvalueringStatusEnum.Overskredet;
    else
        return EvalueringStatusEnum.ManglerIndsendelse;
}

export const GetAttestationStatus = (forloebSlutDato: Date, forloebGodkendt: boolean) => {
    if (forloebGodkendt)
        return AttestationStatusEnum.Godkendt;
    else if (forloebSlutDato < new Date().addDays(30))
        return AttestationStatusEnum.ManglerGodkendelse;
    else
        return AttestationStatusEnum.IkkeKlarTilGodkendelse;
}
export class DashboardListUkoModel {
    uddannelsesstedNavn: string
    antalForloeb: number
    antalForloebManglerVejleder: number
    antalKlarmeldteKompetencer: number
    antalUddannelsesplaner: number
    minDageSidenSidsteUddannelsesplan: number | null
    evalueretStatus: EvalueringStatusEnum[]
    attestationStatus: AttestationStatusEnum[]
    introVejledersamtalerStatus: VejledersamtaleStatusEnum[]
    justerendeVejledersamtalerStatus: VejledersamtaleStatusEnum[]
    afsluttendeVejledersamtalerStatus: VejledersamtaleStatusEnum[]
    foersteUddannelsesplanStatus: DashboardUddannelsesplanStatusEnum[]

    static Build(responseModel: DashboardListUkoResponseModel): DashboardListUkoModel {
        let model = new DashboardListUkoModel();
        model.uddannelsesstedNavn = responseModel.uddannelsesstedNavn;
        model.antalForloeb = responseModel.antalForloeb;
        model.antalForloebManglerVejleder = responseModel.antalForloebManglerVejleder;
        model.antalKlarmeldteKompetencer = responseModel.antalKlarmeldteKompetencer;
        model.antalUddannelsesplaner = responseModel.antalUddannelsesplaner;
        model.minDageSidenSidsteUddannelsesplan = responseModel.minDageSidenSidsteUddannelsesplan;
        model.evalueretStatus = responseModel.forloebList.map((forloeb) => GetEvalueringStatus(dateTimeStringFromApiToDate(forloeb.slutdato), forloeb.evalueret));
        model.attestationStatus = responseModel.forloebList.map((forloeb) => GetAttestationStatus(dateTimeStringFromApiToDate(forloeb.slutdato), forloeb.godkendt));
        model.introVejledersamtalerStatus = responseModel.introVejledersamtalerStatus;
        model.justerendeVejledersamtalerStatus = responseModel.justerendeVejledersamtalerStatus;
        model.afsluttendeVejledersamtalerStatus = responseModel.afsluttendeVejledersamtalerStatus;
        model.foersteUddannelsesplanStatus = responseModel.foersteUddannelsesplanStatus;

        return model;
    }
}

class ForloebUkoResponseModel {
    godkendt: boolean
    evalueret: boolean
    slutdato: string
}

export type DashboardListUkoResponseModel = {
    uddannelsesstedNavn: string
    antalForloeb: number
    antalForloebManglerVejleder: number
    antalKlarmeldteKompetencer: number
    antalUddannelsesplaner: number
    minDageSidenSidsteUddannelsesplan: number | null
    forloebList: ForloebUkoResponseModel[]
    introVejledersamtalerStatus: VejledersamtaleStatusEnum[]
    justerendeVejledersamtalerStatus: VejledersamtaleStatusEnum[]
    afsluttendeVejledersamtalerStatus: VejledersamtaleStatusEnum[]
    foersteUddannelsesplanStatus: DashboardUddannelsesplanStatusEnum[]
}
